import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUbuntuComponent } from './simple-icons-ubuntu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUbuntuComponent ],
    exports:      [ SimpleIconsUbuntuComponent ],
    bootstrap:    []
})
export class SimpleIconsUbuntuModule {}
